export function getFilenameFromUrl(url: string): string {
  return decodeURI(url.split('/').pop() ?? '');
}
